export default "__VITE_ASSET__sKIGwgL5__"